import { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { capeData } from "../../utils/data/CapeData";
import DisplaySearch from "./display/DisplaySearch";
import CosmeticCard from "./display/CosmeticCard";

export default function CapeDisplay() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedRarities, setSelectedRarities] = useState([]);
  const [username] = useState(localStorage.getItem("username") || "");
  const [ownedcapes, setOwnedcapes] = useState([]);
  const [sortOption, setSortOption] = useState("rarity");
  const [groupByObtain, setGroupByObtain] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const rarityOrder = useMemo(
    () => [
      "common",
      "rare",
      "epic",
      "legendary",
      "limited",
      "exotic",
      "partner",
    ],
    []
  );

  const handleRarityChange = (e) => {
    const { value, checked } = e.target;
    setSelectedRarities((prev) =>
      checked ? [...prev, value] : prev.filter((r) => r !== value)
    );
  };

  useEffect(() => {
    const sorted = [...capeData].sort(
      (a, b) => rarityOrder.indexOf(a.rarity) - rarityOrder.indexOf(b.rarity)
    );
    setData(sorted);
  }, [rarityOrder]);

  useEffect(() => {
    if (!username) return;
    axios
      .get(`https://app.zeqa.net/api/player/item/${username}`)
      .then((res) => {
        const owned = res.data?.result?.[0]?.ownedcape;
        if (owned) setOwnedcapes(owned.split(","));
      })
      .catch(console.error);
  }, [username]);

  useEffect(() => {
    if (groupByObtain) setSortOption("default");
    else setSortOption("rarity");
  }, [groupByObtain]);

  useEffect(() => {
    let newData = [...data];

    // Filter by search term
    if (searchTerm) {
      const kw = searchTerm.toLowerCase();
      newData = newData.filter(
        (item) =>
          item.name.toLowerCase().includes(kw) ||
          item.rarity.toLowerCase().includes(kw) ||
          item.obtain.join(",").toLowerCase().includes(kw)
      );
    }

    // Filter by rarity
    if (selectedRarities.length) {
      newData = newData.filter((item) =>
        selectedRarities.includes(item.rarity)
      );
    }

    // Sorting
    switch (sortOption) {
      case "rarity":
      case "default":
        newData.sort(
          (a, b) =>
            rarityOrder.indexOf(a.rarity) - rarityOrder.indexOf(b.rarity)
        );
        break;
      case "alphabetical":
        newData.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case "Number ID":
        newData = newData.sort((a, b) => Number(a.id) - Number(b.id));
        break;
      case "owned":
        newData = newData
          .filter((item) => ownedcapes.includes(item.id))
          .sort(
            (a, b) =>
              rarityOrder.indexOf(a.rarity) - rarityOrder.indexOf(b.rarity)
          );
        break;
      case "unowned":
        newData = newData
          .filter((item) => !ownedcapes.includes(item.id))
          .sort(
            (a, b) =>
              rarityOrder.indexOf(a.rarity) - rarityOrder.indexOf(b.rarity)
          );
        break;
      default:
        break;
    }

    setFilteredData(newData);
  }, [selectedRarities, sortOption, data, ownedcapes, rarityOrder, searchTerm]);

  const groupedByObtain = useMemo(() => {
    const groups = {};
    filteredData.forEach((item) => {
      item.obtain.forEach((method) => {
        if (!groups[method]) groups[method] = [];
        groups[method].push(item);
      });
    });
    return groups;
  }, [filteredData]);

  return (
    <div>
      <br />
      <br />

      <div className="w-layout-grid grid-title">
        <div className="zeqa--subtitle">Cosmetics</div>
        <h1 className="large-heading">capes</h1>
      </div>

      <div className="cosmetic_display_header">
        <h2 style={{ fontSize: "20px", textAlign: "center" }}>
          {filteredData.length} results
        </h2>
        <DisplaySearch
          fulldata={capeData}
          selectedRarities={selectedRarities}
          handleRarityChange={handleRarityChange}
          sortOption={sortOption}
          setSortOption={setSortOption}
          groupByObtain={groupByObtain}
          setGroupByObtain={setGroupByObtain}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
      </div>

      {!groupByObtain && (
        <div className="w-layout-grid oreuigrid">
          {filteredData.map((item, idx) => (
            <CosmeticCard
              key={idx}
              item={item}
              nameColor={ownedcapes.includes(item.id) ? "#00ff73" : "white"}
            />
          ))}
        </div>
      )}

      {groupByObtain &&
        Object.keys(groupedByObtain)
          .sort((a, b) => a.localeCompare(b))
          .map((method) => (
            <div key={method}>
              <h2 className="obtain-heading">{method}</h2>
              <div className="w-layout-grid oreuigrid">
                {groupedByObtain[method]
                  .sort(
                    (a, b) =>
                      rarityOrder.indexOf(a.rarity) -
                      rarityOrder.indexOf(b.rarity)
                  )
                  .map((item, idx) => (
                    <CosmeticCard
                      key={`${method}-${idx}`}
                      item={item}
                      nameColor={
                        ownedcapes.includes(item.id) ? "#00ff73" : "white"
                      }
                    />
                  ))}
              </div>
            </div>
          ))}
    </div>
  );
}
